<template>
  <div>
    <document-section
      :documents="projectDueDiligence"
      heading="Project Due Diligence"
      store="projects"
      tag="projectDueDiligence" />
    <document-section
      :documents="professionalReports"
      heading="Professional Reports"
      store="projects"
      tag="professionalReports" />
    <document-section
      :documents="legals"
      heading="Offer &amp; Legal Documents"
      store="projects"
      tag="legals" />
    <document-section
      :documents="correspondence"
      heading="Correspondence"
      store="projects"
      tag="correspondence" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import DocumentSection from './DocumentSection.vue'

export default {
  name: 'ProjectDocuments',

  components: {
    DocumentSection
  },

  computed: {
    ...mapGetters({
      correspondence: 'core/projects/correspondence',
      legals: 'core/projects/legals',
      professionalReports: 'core/projects/professionalReports',
      projectDueDiligence: 'core/projects/projectDueDiligence'
    })
  }
}
</script>
